if (sessionStorage.getItem('prkl_scroll_y') !== null) {
  document.documentElement.style.opacity = '0';
}

(function () {
  function getVariants() {
    const el = document.querySelector('script[id^="prkl-all-variants-"]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  let navigating = false;

  function navigateToFirstVariantWithOptions(fixedOptions) {
    if (navigating) return;
    const variants = getVariants();
    if (!variants.length) return;

    const matches = variants.filter(v =>
      fixedOptions.every((opt, i) => opt === null || v.options[i] === opt)
    );
    if (!matches.length) return;

    const best = matches.find(v => v.available) || matches[0];
    const currentParams = new URLSearchParams(window.location.search);
    if (currentParams.get('variant') === String(best.id)) return;

    navigating = true;
    sessionStorage.setItem('prkl_scroll_y', window.scrollY);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', best.id);
    window.location.href = url.toString();
  }

  function restoreScroll() {
    const savedY = sessionStorage.getItem('prkl_scroll_y');
    if (savedY === null) {
      document.documentElement.style.opacity = '';
      return;
    }
    sessionStorage.removeItem('prkl_scroll_y');
    window.scrollTo({ top: parseInt(savedY), behavior: 'instant' });

    requestAnimationFrame(() => {
      document.documentElement.style.opacity = '';
    });
  }

  function hideButtonInstantly() {
    const btn = document.querySelector('[name="add"]');
    if (btn) btn.style.visibility = 'hidden';
  }

  function showButton() {
    const btn = document.querySelector('[name="add"]');
    if (btn) btn.style.visibility = '';
  }

  function init() {
    restoreScroll();

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset'));
    if (!fieldsets.length) return;

    fieldsets.forEach((fieldset, changedIndex) => {
      fieldset.addEventListener('change', (e) => {
        if (e.target.type !== 'radio') return;
        if (navigating) return;

        hideButtonInstantly();

        const fixedOptions = fieldsets.map((fs, i) => {
          if (i < changedIndex) return fs.querySelector('input[type="radio"]:checked')?.value || null;
          if (i === changedIndex) return e.target.value;
          return null;
        });

        const variants = getVariants();
        const matches = variants.filter(v =>
          fixedOptions.every((opt, i) => opt === null || v.options[i] === opt)
        );
        const best = matches.find(v => v.available) || matches[0];
        const currentParams = new URLSearchParams(window.location.search);

        if (!best || currentParams.get('variant') === String(best.id)) {
          setTimeout(showButton, 200); // 400ms → 200ms
          return;
        }

        navigateToFirstVariantWithOptions(fixedOptions);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
